import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import './plugins/element.js'
import './style/index.scss'
import './style/element-variables.scss'


Vue.config.productionTip = false

Vue.prototype.publicData = {
  serverUrl: process.env.NODE_ENV === 'development' ? "/" : "/"
}

Vue.filter('time', function (n) {
  let mm = parseInt(n / 60.0)
  let ss = parseInt(n % 60.0)
  mm = mm < 10 ? '0' + mm : mm
  ss = ss < 10 ? '0' + ss : ss
  return mm + "'" + ss
})
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': require('./language/language-zh'),
    'en': require('./language/language-en'),
    'zh-hk': require('./language/language-hk')
  },
  silentTranslationWarn: true
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
